export { Subject } from './src/subject.es';



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client-universal/packages/observer-pattern/index.es